import React, { useEffect, useRef, useState } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useParams,
} from "react-router-dom";
import routes from "../../routes";
import NotFound from "../../Views/NotFound/NotFound";
import Sidebar from "../Sidebar";
import { MainNav } from "../MuiTable";
import { useMediaQuery } from "@mui/material";
import { Grid } from "@mui/material";

const Donor = () => {
  const mainContent = useRef(null);
  const location = useLocation();
  const { CompanyUrl } = useParams();
  const [isSidebarClosed, setIsSidebarClosed] = useState(false);
  const [isSidebarDisplay, setIsSidebarDisplay] = useState(true);
  const isMediumScreen = useMediaQuery("(max-width:767px)", { noSsr: true });

  // Reset sidebar state when screen size changes
  useEffect(() => {
    if (!isMediumScreen) {
      setIsSidebarDisplay(true);
      setIsSidebarClosed(false);
    } else {
      setIsSidebarDisplay(false);
    }
  }, [isMediumScreen]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) {
      mainContent.current.scrollTop = 0;
    }
  }, [location]);

  const getRoutes = (routes) => {
    return routes?.map((prop, key) => {
      if (prop.layout === "/:CompanyUrl/donors" && !prop.isCollapse) {
        return (
          <Route path={prop?.path} element={prop?.component} key={key} exact />
        );
      } else {
        if (prop.children) {
          return prop?.children?.map((item) => {
            return (
              <Route
                path={item?.path}
                element={item?.component}
                key={key}
                exact
              />
            );
          });
        }
      }
    });
  };

  return (
    <Grid
      style={{
        backgroundColor: "#ffffff",
        width: "100vw",
        height: "100vh",
        overflow: "auto",
      }}
    >
      <Sidebar
        layout={`/:CompanyUrl/donors`}
        isSidebarClosed={isSidebarClosed}
        setIsSidebarClosed={setIsSidebarClosed}
        isSidebarDisplay={isSidebarDisplay}
        setIsSidebarDisplay={setIsSidebarDisplay}
      />

      <MainNav
        layout="/:CompanyUrl/donors"
        isSidebarDisplay={isSidebarDisplay}
        setIsSidebarDisplay={setIsSidebarDisplay}
        isSidebarClosed={isSidebarClosed}
      />
      <Grid
        className="main-content"
        style={{
          marginLeft: !isMediumScreen
            ? isSidebarClosed
              ? "150px"
              : "300px"
            : "15px",
        }}
        ref={mainContent}
      >
        <Grid style={{ width: "95%" }}>
          <React.Suspense fallback={null}>
            <Routes>
              {getRoutes(routes)}
              {/* JOB-3220 + JOB-3225: real 404 instead of silent /index redirect */}
              <Route path="*" element={<NotFound homePath={`/${CompanyUrl}/donors/index`} />} />
            </Routes>
          </React.Suspense>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Donor;
